import * as React from 'react';
import Button from '@mui/material/Button';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { Link as RouterLink, useSearchParams } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import Logo from '../assets/logo-sebrae.png';
import LogoRight from '../assets/logo-sebrae-one.svg';
import CircularProgress from '@mui/material/CircularProgress';
import { useNavigate } from 'react-router-dom';
import { useForm, Controller } from 'react-hook-form';
import CustomizedDialogs from '../components/ModalAlert';
import VisibilityIcon from '@mui/icons-material/Visibility';
import InputAdornment from '@mui/material/InputAdornment';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import OutlinedInput from '@mui/material/OutlinedInput';
import IconButton from '@mui/material/IconButton';

import { handleHttpError } from '../utils';

export const AlterarSenhaPage = () => {
  const { alterarSenha, user, logout } = useAuth();
  const [loading, setLoading] = React.useState(false);
  const [visible, setVisible] = React.useState(false);
  const [mostrarSenhaAtual, setMostrarSenhaAtual] = React.useState(false);
  const [mostrarSenhaNova, setMostrarSenhaNova] = React.useState(false);
  const [mostrarSenhaConfirmar, setMostrarSenhaConfirmar] =
    React.useState(false);
  const [message, setMessage] = React.useState('');
  const [type, setType] = React.useState('');
  const navigate = useNavigate();
  const { handleSubmit, control, watch } = useForm();
  let [searchParams, setSearchParams] = useSearchParams();

  const onSubmit = async (data) => {
    setLoading(true);
    try {
      const payload = {
        cpf: user ? user.cpf : null,
        senha: data.senhaAtual,
        senhanova: data.novaSenha,
        token: searchParams.get('token'),
      };

      if (user) {
        if (user.cnpj) {
          payload.cnpj = user.cnpj.replace(/[^a-zA-Z0-9]/g, '');
        } else {
          payload.cnpj = user.cpf.replace(/\D/g, '');
        }
      }

      const result = await alterarSenha(payload);
      setMessage(result.data.message);
      setType('success');
      setVisible(true);
      if (user && user.role_id == 6) {
        logout();
      } else {
        navigate(searchParams.get('token') ? '/' : '/dashboard/painel-notas', {
          replace: true,
        });
      }
    } catch (error) {
      setLoading(false);
      setMessage(
        `${handleHttpError(error)}. Entre em contato no telefone: ${
          process.env.REACT_APP_TELEFONE_SUPORTE
        }`,
      );
      setType('error');
      setVisible(true);
    }
  };

  const password = watch('novaSenha', '');

  return (
    <Grid container spacing={0}>
      <Grid
        item
        sm={6}
        style={{
          backgroundColor: '#00669e',
          height: '100vh',
          display: 'flex',
          justifyContent: 'start',
          alignItems: 'start',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
            marginTop: 20,
            marginLeft: 10,
          }}
        >
          <Typography component="h1" variant="h5" align="left" color={'#fff'}>
            PORTAL DE FORNECEDORES SEBRAE
          </Typography>
          <img src={LogoRight} style={{ marginTop: 40 }} />
        </Box>
      </Grid>
      <Grid item sm={6}>
        <CustomizedDialogs
          content={message}
          btnTxt={type === 'success' ? 'Ir para login' : 'Ok'}
          type={type}
          handleClose={setVisible}
          visible={visible}
        />
        <img src={Logo} />
        <Box
          sx={{
            marginTop: 8,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Typography
            component="h1"
            variant="h5"
            align="left"
            color={'#00669e'}
            style={{ width: '60%', fontSize: 16 }}
          >
            Crie uma senha definitiva
          </Typography>
          <Box style={{ width: '60%' }} sx={{ mt: 1 }}>
            <form onSubmit={handleSubmit(onSubmit, (error) => {})}>
              {!searchParams.get('token') && (
                <Controller
                  name="senhaAtual"
                  control={control}
                  defaultValue=""
                  rules={{ required: 'Senha atual é obrigatório' }}
                  render={({
                    field: { onChange, value },
                    fieldState: { error },
                  }) => (
                    <OutlinedInput
                      fullWidth
                      value={value}
                      error={error}
                      type={mostrarSenhaAtual ? 'text' : 'password'}
                      helperText={error && error.message}
                      onChange={onChange}
                      placeholder="Senha atual"
                      style={{ marginTop: '1rem' }}
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            edge="end"
                            onClick={() => {
                              setMostrarSenhaAtual(!mostrarSenhaAtual);
                            }}
                          >
                            {mostrarSenhaAtual ? (
                              <VisibilityOffIcon />
                            ) : (
                              <VisibilityIcon />
                            )}
                          </IconButton>
                        </InputAdornment>
                      }
                    />
                  )}
                />
              )}

              <Controller
                name="novaSenha"
                control={control}
                defaultValue=""
                rules={{
                  required: 'Nova senha é obrigatório',
                }}
                render={({
                  field: { onChange, value },
                  fieldState: { error },
                }) => (
                  <OutlinedInput
                    fullWidth
                    value={value}
                    error={error}
                    type={mostrarSenhaNova ? 'text' : 'password'}
                    helperText={error && error.message}
                    onChange={onChange}
                    placeholder="Senha nova"
                    style={{ marginTop: '1rem' }}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          edge="end"
                          onClick={() => {
                            setMostrarSenhaNova(!mostrarSenhaNova);
                          }}
                        >
                          {mostrarSenhaNova ? (
                            <VisibilityOffIcon />
                          ) : (
                            <VisibilityIcon />
                          )}
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                )}
              />

              <Controller
                name="confirmaSenha"
                control={control}
                defaultValue=""
                rules={{
                  required: 'Confirmar senha é obrigatório',
                  validate: (value) =>
                    value === password || 'As senhas não conferem',
                }}
                render={({
                  field: { onChange, value },
                  fieldState: { error },
                }) => (
                  <OutlinedInput
                    fullWidth
                    value={value}
                    error={error}
                    type={mostrarSenhaConfirmar ? 'text' : 'password'}
                    helperText={error && error.message}
                    onChange={onChange}
                    placeholder="Confirmar Senha"
                    style={{ marginTop: '1rem' }}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          edge="end"
                          onClick={() => {
                            setMostrarSenhaConfirmar(!mostrarSenhaConfirmar);
                          }}
                        >
                          {mostrarSenhaConfirmar ? (
                            <VisibilityOffIcon />
                          ) : (
                            <VisibilityIcon />
                          )}
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                )}
              />

              <Button
                type="submit"
                fullWidth
                variant="contained"
                style={{ backgroundColor: '#00669e' }}
                sx={{ mt: 3, mb: 2 }}
              >
                <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                  {loading ? (
                    <CircularProgress color={'inherit'} size={25} />
                  ) : (
                    <span>Enviar</span>
                  )}
                </Box>
              </Button>
              <Grid container sm={12} item justifyContent={'space-between'}>
                <Grid item xs={6}></Grid>
                <Grid
                  item
                  xs={6}
                  display={'flex'}
                  justifyContent={'flex-end'}
                  alignItems={'center'}
                >
                  <RouterLink to="/">
                    <span variant="body2">{'Voltar ao login'}</span>
                  </RouterLink>
                </Grid>
              </Grid>
            </form>
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
};
